import { Props_SnippetAwards } from './Awards.props'
import { CompileMarkdown } from '@ClientBase/React/ReactSnippetMDCompiler'

const SnippetAwards = (props: Props_SnippetAwards) => {
    const { heading, paragraph, snippet, repeatable_awardItems: items = [] } = props

    const isHeadingVisible = heading?.visibility?.value
    const headingContent = heading?.content?.value
    const paragraphText = paragraph?.text?.value

    const backgroundColourClass = snippet?.backgroundColour?.value
        ? `snippet-awards--bg--${snippet.backgroundColour.value}`
        : ''
    const sectionClasses = ['snippet-awards', backgroundColourClass].filter(Boolean).join(' ')

    return (
        <section className={sectionClasses}>
            <div className="snippet-awards__container">
                {isHeadingVisible && headingContent && (
                    <div className="snippet-awards__heading">
                        {CompileMarkdown(headingContent)}
                    </div>
                )}
                {paragraphText && (
                    <div className="snippet-awards__paragraph">
                        {CompileMarkdown(paragraphText)}
                    </div>
                )}
                {items.length > 0 && (
                    <ul className="snippet-awards__list">
                        {items.map((item, index) => {
                            const src = item.image?.value
                            if (!src) return null
                            const alt = item.alt?.value || ''
                            const href = item.linkHref?.value
                            const openInNewTab = item.linkTarget?.value
                            const image = (
                                <img
                                    loading="lazy"
                                    src={src}
                                    alt={alt}
                                    className="snippet-awards__image"
                                />
                            )
                            return (
                                <li key={'award-item-' + index} className="snippet-awards__item">
                                    {href ? (
                                        <a
                                            href={href}
                                            target={openInNewTab ? '_blank' : '_self'}
                                            rel={openInNewTab ? 'noopener noreferrer' : undefined}
                                            className="snippet-awards__link"
                                        >
                                            {image}
                                        </a>
                                    ) : (
                                        image
                                    )}
                                </li>
                            )
                        })}
                    </ul>
                )}
            </div>
        </section>
    )
}

export default SnippetAwards
